import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import TextStyle from "@/components/stickers/TextStyle";
import { ELEMENTS } from "@/lib/stickerDesign";

export default function ElementPanel({ elements, setElements, selected, setSelected }) {
  const el = elements[selected];
  const patch = (p) => setElements(elements.map((x, i) => (i === selected ? { ...x, ...p } : x)));
  const add = (key) => { setElements([...elements, { key, x: 0.1, y: 0.1, size: key === "logo" ? 54 : 9, bold: false, text: key === "text" ? "Your text" : "" }]); setSelected(elements.length); };

  return (
    <div className="space-y-4" data-testid="element-panel">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-2">Add a line</p>
        <div className="flex flex-wrap gap-1.5">
          {Object.entries(ELEMENTS).map(([k, label]) => (
            <Button key={k} size="sm" variant="outline" onClick={() => add(k)} data-testid={`add-el-${k}`}><Plus size={12} /> {label}</Button>
          ))}
        </div>
      </div>
      {el ? (
        <div className="border rounded-md p-3 space-y-3" data-testid="selected-element">
          <p className="text-sm font-medium">{ELEMENTS[el.key]}</p>
          {el.key === "text" && (
            <div className="space-y-1"><Label className="text-xs">Text</Label>
              <Input value={el.text} maxLength={200} onChange={(e) => patch({ text: e.target.value })} data-testid="el-text-input" /></div>
          )}
          {el.key === "number" && (
            <div className="space-y-1"><Label className="text-xs">Text before the number (leave blank for none)</Label>
              <Input value={el.text} maxLength={20} placeholder="e.g. Job #" onChange={(e) => patch({ text: e.target.value })} data-testid="el-prefix-input" /></div>
          )}
          {el.key === "logo" && (
            <div className="space-y-1"><Label className="text-xs">Max width (in, 0 = no limit)</Label>
              <Input type="number" step={0.05} min={0} max={10} value={el.max_w || 0} className="h-8" onChange={(e) => patch({ max_w: Math.min(10, Math.max(0, parseFloat(e.target.value) || 0)) })} data-testid="el-maxw-input" /></div>
          )}
          <div className="grid grid-cols-3 gap-2">
            <div className="space-y-1"><Label className="text-xs">{el.key === "logo" ? "Height (pt)" : "Size (pt)"}</Label>
              <Input type="number" step={0.5} min={3} max={96} value={el.size} onChange={(e) => patch({ size: Math.min(96, Math.max(3, parseFloat(e.target.value) || 3)) })} className="h-8" data-testid="el-size-input" /></div>
            <div className="space-y-1"><Label className="text-xs">Left (in)</Label>
              <Input type="number" step={0.01} value={el.x} onChange={(e) => patch({ x: parseFloat(e.target.value) || 0 })} className="h-8" data-testid="el-x-input" /></div>
            <div className="space-y-1"><Label className="text-xs">Top (in)</Label>
              <Input type="number" step={0.01} value={el.y} onChange={(e) => patch({ y: parseFloat(e.target.value) || 0 })} className="h-8" data-testid="el-y-input" /></div>
          </div>
          {el.key !== "logo" && <TextStyle el={el} patch={patch} applyAll={(p) => setElements(elements.map((x) => (x.key === "logo" ? x : { ...x, ...p })))} />}
          <div className="flex">
            <Button size="sm" variant="outline" className="w-full text-destructive border-destructive/40 hover:bg-destructive/10" onClick={() => { setElements(elements.filter((_, i) => i !== selected)); setSelected(null); }} data-testid="el-remove-button"><Trash2 size={14} /> Remove</Button>
          </div>
        </div>
      ) : <p className="text-sm text-muted-foreground">Click a line on the sticker to edit it.</p>}
    </div>
  );
}
